if (!document.body.classList.contains('block-editor-page')) {
  const elements = document.querySelectorAll('.credo-timeline-about__content-col > *')

  elements.forEach((el, i) => {
    el.style.setProperty('--delay', `${i * 0.15}s`)
    el.classList.add('will-animate')
  })

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible')
          observer.unobserve(entry.target)
        }
      })
    },
    { threshold: 0.15 },
  )

  elements.forEach((el) => observer.observe(el))
}
